<div class="dialog-container">
  <div layout="row" layout-align="space-between center" flex>
    <span mat-dialog-title>Стартирай нова верификация</span>
    <button
      tabindex="-1"
      mat-icon-button
      class="close-button"
      [disabled]="isLoading"
      (click)="onNoClick()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr />

  @if (!isLoading) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-dialog-content class="svd-content">
        <mat-form-field appearance="outline" class="svd-flow">
          <mat-label>Метод на верификация</mat-label>
          <mat-select
            formControlName="flow"
            (selectionChange)="onFlowChange($event.value, docsPanel)"
          >
            <mat-select-trigger>
              @let currentValue = form.get('flow')?.value;
              @for (opt of FLOW_OPTIONS; track opt.value) {
                @if (opt.value === currentValue) {
                  <span class="svd-flow-option">
                    <img
                      class="svd-flow-option__logo"
                      [src]="opt.iconUrl"
                      [alt]="opt.label"
                    />
                    <span>{{ opt.label }}</span>
                  </span>
                }
              }
            </mat-select-trigger>

            @for (opt of FLOW_OPTIONS; track opt.value) {
              <mat-option [value]="opt.value">
                <span class="svd-flow-option">
                  <img
                    class="svd-flow-option__logo"
                    [src]="opt.iconUrl"
                    [alt]="opt.label"
                  />
                  <span>{{ opt.label }}</span>
                </span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @let isDocsTransferAvailable =
          form.get('flow')?.value === FLOW.INTERNAL;

        <mat-expansion-panel
          #docsPanel
          class="svd-docs-expansion"
          [disabled]="!isDocsTransferAvailable"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Прехвърляне на документи
              <span class="svd-docs-expansion__hint">
                ({{ selectedSlotsCount }} от 3 избрани)
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          @if (loadingDocs) {
            <div class="svd-docs-loading">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          } @else {
            <div class="svd-slots">
              @for (slot of slotControls; track trackSlot($index, slot)) {
                @let currentTile = getCurrentTile(slot.key);
                @let total = tilesByKey[slot.key]?.length ?? 0;
                @let index = (cursorByKey[slot.key] ?? 0) + 1;

                <div class="svd-slot">
                  <div class="svd-slot__header">
                    <span class="svd-slot__title">{{ slot.label }}</span>
                    @if (form.get(slot.formControlName)?.value) {
                      <mat-icon
                        class="svd-slot__check"
                        fontSet="material-symbols-outlined"
                        >check_circle</mat-icon
                      >
                    }
                  </div>

                  @if (!slot.hasOptions || !currentTile) {
                    <div class="svd-slot__empty">Няма документи</div>
                  } @else {
                    <div
                      class="svd-tile"
                      [class.svd-tile--selected]="isSelected(slot, currentTile)"
                      [matTooltip]="
                        isSelected(slot, currentTile)
                          ? 'Избрана'
                          : 'Натисни за избор'
                      "
                      matTooltipPosition="above"
                      (click)="onTileClick(slot, currentTile)"
                    >
                      @if (isSelected(slot, currentTile)) {
                        <span class="svd-tile__check">
                          <mat-icon
                            fontSet="material-symbols-outlined"
                            class="fill"
                            >check_circle</mat-icon
                          >
                        </span>
                      }

                      @if (currentTile.isFromPrev && currentTile.state) {
                        <span
                          class="svd-tile__badge svd-tile__badge--{{
                            currentTile.stateClass
                          }}"
                        >
                          {{ currentTile.state }}
                        </span>
                      }

                      @if (currentTile.imageUrl && !currentTile.loading) {
                        <img
                          class="svd-tile__img"
                          [src]="currentTile.imageUrl"
                          [alt]="currentTile.name"
                        />
                        <button
                          type="button"
                          class="svd-tile__fullscreen-btn"
                          [matTooltip]="'Преглед в голям размер'"
                          (click)="openPreview(currentTile, $event)"
                        >
                          <span class="material-symbols-outlined"
                            >fullscreen</span
                          >
                        </button>
                      } @else if (currentTile.loading) {
                        <div class="svd-tile__overlay">
                          <mat-spinner [diameter]="22"></mat-spinner>
                        </div>
                      } @else if (currentTile.error) {
                        <div class="svd-tile__overlay svd-tile__overlay--error">
                          <mat-icon>broken_image</mat-icon>
                        </div>
                      } @else {
                        <div class="svd-tile__overlay">
                          <mat-icon>image</mat-icon>
                        </div>
                      }
                    </div>

                    <div class="svd-nav">
                      <span class="svd-nav__spacer"
                        >{{ index }} / {{ total }}</span
                      >
                      <div class="svd-nav__arrows">
                        <button
                          type="button"
                          class="svd-nav__btn"
                          [disabled]="
                            total <= 1 || (cursorByKey[slot.key] ?? 0) === 0
                          "
                          (click)="prevTile(slot.key)"
                        >
                          <mat-icon>arrow_back</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="svd-nav__btn"
                          [disabled]="
                            total <= 1 ||
                            (cursorByKey[slot.key] ?? 0) >= total - 1
                          "
                          (click)="nextTile(slot.key)"
                        >
                          <mat-icon>arrow_forward</mat-icon>
                        </button>
                      </div>
                      <span class="svd-nav__counter">
                        {{ index }} / {{ total }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      </mat-dialog-content>

      <div flex layout="row" layout-align="center center">
        <button flex type="submit" color="primary" mat-raised-button>
          Стартирай
        </button>
      </div>
    </form>
  } @else {
    <div class="progress-spinner-container detail-spinner">
      <mat-spinner
        class="progress-spinner"
        strokeWidth="10"
        [diameter]="100"
      ></mat-spinner>
    </div>
  }
</div>
